module.exports = __webpack_public_path__ + "img/financeiro-cover.eb9152c0.jpg";